'use strict';

angular.module('shiftTraderApp')
  .controller('availabilityPolicyModal', function ($uibModalInstance, OrganizationSettings, Session, params) {
    var vm = this
    
    vm.org = params.org

    vm.state = {
      canEdit: params.canEdit || false,
      policyTextChanged: false,
      policyText: vm.org.organization_config.availability_policy_text
    }

    vm.close = $uibModalInstance.close
    vm.done = function() {
      Session.getCurrentOrg(true)
        .then(function (org) {
          $uibModalInstance.close(org.organization_config)
        })
    }
  })
